module.exports = __webpack_public_path__ + "static/img/hexib4.bc740fb8.jpg";